import { Box, Divider } from "@mui/material";
import { SidebarMenuItem } from "./SidebarMenuItem";

export const SidebarMenuSubItem = ({
  title,
  pages,
  collapsed,
  theLast = false,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      {pages.map(
        (page) =>
          page.enabled && (
            <SidebarMenuItem
              key={page.title}
              title={page.title}
              path={page.path}
              icon={page.icon}
              collapsed={collapsed}
              notPermitted={page.notPermitted}
            />
          )
      )}
      {!theLast && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            height: "10px",
            width: "auto",
          }}
        >
          <Divider sx={{ flexGrow: 1 }} />
        </Box>
      )}
    </Box>
  );
};
